/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * Sagas for Bills
 *
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.25.0
 */

import { SagaIterator } from 'redux-saga';
import { all, put, take, takeEvery } from 'redux-saga/effects';

import { LOAD_INTERNAL_TRANSLATIONS_SUCCESS } from '@/main/modules/internationalization/constants';
import {
    onboardingInitStartAction,
    onboardingPageReadyForStartAction,
} from '@/main/modules/onboarding/onboardingActions';
import { ONBOARDING_INIT_SUCCESS } from '@/main/modules/onboarding/onboardingConstants';
import { EOnboardingPage } from '@/main/modules/onboarding/types/onboardingTypes';
import { GET_BASKET_COUNT_SUCCESSFUL, LOAD_TABLE_META_SUCCESSFUL } from '@components/Table/constants/actionConstants';

import { BILLS_INIT_ONBOARDING } from './billsConstants';

export function* initBillsOnboardingSaga(): SagaIterator {
    yield all([
        take(LOAD_INTERNAL_TRANSLATIONS_SUCCESS),
        take(LOAD_TABLE_META_SUCCESSFUL),
        take(GET_BASKET_COUNT_SUCCESSFUL),
    ]);

    yield put(onboardingInitStartAction({ page: EOnboardingPage.bills }));
    yield take(ONBOARDING_INIT_SUCCESS);

    yield put(onboardingPageReadyForStartAction());
}

export function* billsSagas(): SagaIterator {
    yield all([takeEvery(BILLS_INIT_ONBOARDING, initBillsOnboardingSaga)]);
}
